import { Navigate, useParams } from "react-router-dom";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import DocsLayout from "@/components/site/DocsLayout";
import PageShell, { Section } from "@/components/site/PageShell";
import { Cards, Note, Prose } from "@/components/site/ui";
import { API_BASE, DOCS, findDoc } from "@/content/docs";

export function Docs() {
  const params = useParams();
  const slug = params["*"] || "";
  const doc = findDoc(slug);
  if (!doc) return <Navigate to="/docs" replace />;
  return <DocsLayout doc={doc} />;
}

export function Developers() {
  const apiDocs = DOCS.filter(d => d.tab === "api");
  return (
    <PageShell eyebrow="Développeurs" title="Construire avec Perform."
      lead="Une API HTTP, des sessions par cookie, et aucune clé à gérer."
      actions={<>
        <Link to="/docs/api/authentification" className="button button-dark">Lire la documentation<ArrowRight size={13} /></Link>
        <Link to="/docs/api/reference" className="button button-outline">Référence des endpoints</Link>
      </>}>
      <Section>
        <Note kind="info">
          L'API publique couvre aujourd'hui l'authentification et l'état du service.
          Les points d'entrée pour les séances et les paiements viendront ensuite —
          voir la <Link to="/roadmap">feuille de route</Link>.
        </Note>
      </Section>

      <Section title="Démarrer en une minute">
        <div className="docs-pre-head"><span>bash</span></div>
        <pre className="docs-pre"><code>{`curl -X POST ${API_BASE}/api/auth/magic-link \\
  -H "Content-Type: application/json" \\
  -H "Origin: https://performcustom.com" \\
  -d '{"email":"vous@exemple.fr"}'`}</code></pre>
        <Prose>
          <p>Ouvrez le lien reçu, et votre client conserve la session. Le détail complet est dans le <Link to="/docs/demarrage">démarrage rapide</Link>.</p>
        </Prose>
      </Section>

      <Section title="Documentation de l'API">
        <Cards cols={2} items={apiDocs.map(d => ({
          title: d.title, text: d.subtitle, to: `/docs/${d.slug}`, linkLabel: "Ouvrir",
        }))} />
      </Section>

      <Section title="Bon à savoir">
        <Prose>
          <ul>
            <li>Base de production : <code>{API_BASE}</code></li>
            <li>Authentification par cookie de session — pensez à <code>credentials: "include"</code>.</li>
            <li>Toute requête modifiante exige un en-tête <code>Origin</code> autorisé.</li>
            <li>10 requêtes par minute et par IP sur les points d'entrée d'authentification.</li>
            <li>Les règles d'usage figurent dans les <Link to="/legal/conditions-developpeurs">conditions développeurs</Link>.</li>
          </ul>
        </Prose>
      </Section>

      <Section title="Une faille ?">
        <Prose>
          <p>Signalez-la via la page <Link to="/securite/divulgation">Divulgation de vulnérabilité</Link>. Accusé de réception sous 72 heures.</p>
        </Prose>
      </Section>
    </PageShell>
  );
}
